module.exports = __webpack_public_path__ + "static/media/inspection-pipeline.937a88a6.jpg";